import React, { memo, forwardRef } from "react";
const SvgReplyArrow1Small = forwardRef((props, svgRef) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M4.5 9H15.75C18.2353 9 20.25 11.0147 20.25 13.5V13.5C20.25 15.9853 18.2353 18 15.75 18H5.93182"
        stroke="#717171"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 5.25L3.75 9L7.5 12.75"
        stroke="#717171"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
SvgReplyArrow1Small.displayName = "SvgReplyArrow1Small";
const MemoForwardRef = memo(SvgReplyArrow1Small);
export default MemoForwardRef;
